import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import LoadingScreen from './Common/LoadingScreen'

const RoleBasedGuard = ({ children }) => {
    const { user, profile, loading, signOut } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (loading) return
        if (!user) return
        if (profile?.role === 'client') {
            ;(async () => {
                try {
                    await signOut()
                } finally {
                    window.location.href = 'https://clientes.gallegosasesores.com'
                }
            })()
        }
    }, [user, profile, loading, signOut])

    if (loading) {
        return <LoadingScreen />
    }

    if (user && profile?.role === 'client') {
        return <LoadingScreen message="Redirigiendo al Portal de Clientes..." />
    }

    return children
}

export default RoleBasedGuard
